<template>
	<div class="animated fadeIn">
		<p class="h4">{{ $t('add_field_to_dataset') }}</p>
		<tooltip label="field name" placement="right">
			<input
				name="field_name"
				:placeholder="$t('field name')"
				v-validate.disable="'required'"
				:class="{'form-control': true, 'is-invalid': errors.has('field_name')}"
				v-model="field.name"
			/>
			<span v-if="errors.has('field_name')" class="text-danger">{{ $t(errors.first('field_name')) }}</span>
		</tooltip>

		<tooltip label="field Type" placement="right">
			<select
				v-model="field.type"
				name="field_type"
				v-validate="'required'"
				:class="{'form-control': true, 'is-invalid': errors.has('field_type')}"
			>
				<template v-for="(f, i) in fieldsTyps">
					<option
						v-if="!f.hidden"
						:value="f.value"
						:disabled="!!f.disabled"
						:key="'f_' + i"
					>{{ f.name }}</option>
				</template>
			</select>
			<span v-if="errors.has('field_type')" class="text-danger">{{ $t(errors.first('field_type')) }}</span>
		</tooltip>
		<button type="button" @click="$emit('addField')" class="btn btn-primary">{{ $t('add') }}</button>
	</div>
</template>
<script>
	export default {
		name: 'add-field',
		props: ['field'],
		data() {
			return {
				// field: {
				// 	name: null,
				// 	type: null,
				// 	permission: 'wr',
				// },
				fieldsTyps: [
					{
						name: 'keyword Type',
						value: 0,
						disabled: 1,
					},
					{
						name: 'Text',
						value: 'text',
					},
					{
						name: 'Number',
						value: 'number',
					},
					{
						name: 'List',
						value: 'list',
						hidden: 1,
					},
					{
						name: 'Location',
						value: 'location',
					},
					{
						name: 'Image',
						value: 'image',
					}
				],
			}
		},

		methods: {
			//
		}
	}
</script>
